<app-sites-shell-frontend [unfilteredSites]="sites" (plantingSitesChange)="sitesUpdated($event)">
    <router-outlet></router-outlet>
</app-sites-shell-frontend>
